import 'lodash.clonedeep'
import 'jquery-ui'
import 'bootstrap-sass'
import 'ekko-lightbox'
import 'bs5-lightbox'
import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import 'jQuery.print'
import 'mailcheck'
import 'whatwg-fetch'
import '@hotwired/turbo-rails'
import './turbo-shim'
import '../controllers/index'
import './google_tag_manager'
import './forms'
import './form_validation'
import './customer'
import './links/translate'
import './layout'
import './orders/opportunities'
import './package'
import './print'
import './registration'
import './category_seating_chart'
import './zopim'
import './botpress'
import './categories'
import './countdown'
import './search'
import './carousel'
import './weather'
import './bynder'
import './customers'
import './links/smooth_scrolling'
import './comparison_table'
import './blogs'
import './breadcrumbs'
import '../shared/tooltip'
import './google_ads'
import './svg_package_zoom'
import '../shared/category_filter'
import './persist_scroll'
import './validate_qe_info_request'
import './validate_privacy_request'
//Images
import '../images'
import '../shared/sentry'

import VueLoader from '../default/vue-loader'
import SeatingChartSortBy from '../shared/seating_chart_sort_by'
import './reservations'
import './fade_in_effect'
import './confirmation'
import '../shared/masonry'
import { trackPurchaseEvent as gtmTrackPurchaseEvent } from './google_tag_manager.js'
import './preview_uploaded_image'

document.addEventListener('turbo:load', () => {

  if (document.getElementById('sort-by-filter')) {
    VueLoader.loadVueComponent(
      SeatingChartSortBy,
      document.getElementById('sort-by-filter')
    )
  }
  if(document.getElementById('purchaseConfirmation')){
    gtmTrackPurchaseEvent()
  }
})
